import { Types } from "../actions/CreateMultiplePMActions";

const initialState = {
    allEquipments: [],
    createMultiplePMRes: {},
};

export const CreateMultiplePMReducer = (state = initialState, action) => { 
    switch (action.type) {
        case Types.SET_ALL_EQUIPMENT_BY_AREA_GROUP:
            return {
                ...state,
                allEquipments: action.payload.data,
            };
        case Types.SET_CREATE_MULTIPLE_PM:
            return {
                ...state,
                createMultiplePMRes: action.payload,
            };
        default:
            return state;
    }
};
